import styles from "./Field.module.css";

export default function Field({
  id,
  label,
  type = "text",
  value,
  onChange,
  error,
  required,
  placeholder,
  autoComplete,
  textarea = false,
}) {
  const inputProps = {
    id,
    name: id,
    value,
    onChange,
    placeholder,
    required,
    autoComplete,
    "aria-invalid": !!error,
    className: `${styles.input} ${error ? styles.invalid : ""}`,
  };
  return (
    <div className={styles.field}>
      <label htmlFor={id} className={styles.label}>
        {label}
        {required && " *"}
      </label>
      {textarea ? (
        <textarea rows={4} {...inputProps} />
      ) : (
        <input type={type} {...inputProps} />
      )}
      {error && (
        <span role="alert" className={styles.error}>
          {error}
        </span>
      )}
    </div>
  );
}
